import { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";
import User from "@/modules/user";

export const PermissionManagerRouteResolver = async function (to: Route, from: Route, next: Function) {
	const userModule = getModule(User);
	await userModule.getContentAdministrators();
	next();
};
